import { render } from "./TaskModal.vue?vue&type=template&id=8fe18c4e"
import script from "./TaskModal.vue?vue&type=script&lang=js"
export * from "./TaskModal.vue?vue&type=script&lang=js"

import "./TaskModal.vue?vue&type=style&index=0&id=8fe18c4e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__